import React, { createContext, ReactElement } from "react";

export const ZModalCloseContext = createContext(
  {} as {
    close?: () => void;
  },
);

type Props = {
  children: ReactElement;
  close?: () => void;
};

export const ZModalCloseContextProvider = ({ children, close }: Props): ReactElement => {
  return <ZModalCloseContext.Provider value={{ close }}>{children}</ZModalCloseContext.Provider>;
};
